<app-display-label
    #thisOne
    label="{{'admin.tools.details.header.details-labels.uid' | translate}}"
    [value]="selectedTool?.toolUid">
</app-display-label>
<app-display-label
    label="{{'admin.tools.details.header.details-labels.setSize' | translate}}"
    [value]="selectedTool?.setSize">
</app-display-label>
<app-display-label
    label="{{'admin.tools.details.header.details-labels.manufacturingLine' | translate}}"
    [value]="selectedTool?.mainLine?.name">
</app-display-label>
<app-display-label
    label="{{'admin.tools.details.header.details-labels.status' | translate}}"
    [value]="selectedTool?.status">
</app-display-label>
<app-display-label
    label="{{'admin.tools.details.header.details-labels.stance' | translate}}"
    [value]="selectedTool?.stance">
</app-display-label>
<div class="validity">
    <app-display-label
        label="{{'admin.tools.details.header.details-labels.isValid' | translate}}"
        [value]="selectedTool?.isAvailableForManufactoring"
        [valueClass]="validForManufacturingColor">
    </app-display-label>
    <app-tooltip
        *ngIf="!loading && !selectedTool?.isAvailableForManufactoring"
        type="important"
        tooltipPosition='left'
        [positionLeft]="-120"
        [record]="notAvailableReason">
    </app-tooltip>
</div>
